var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGameBet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 10,
    viewBox: "0 0 74 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_16373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.91118 4.45614V5.59648C8.91118 7.82457 7.76294 10 4.84178 10C1.9206 10 0.333374 7.92981 0.333374 5.01752C0.333374 2.10526 1.9206 0 4.82489 0C6.95247 0 8.28642 1.1579 8.6579 2.92982H6.63161C6.42899 2.21053 5.82113 1.78947 4.82489 1.78947C3.17012 1.78947 2.32585 3.1579 2.32585 4.98248C2.32585 6.807 3.15324 8.21052 4.84178 8.21052C6.27704 8.21052 6.93556 7.33333 6.96932 6.10529H4.75735V4.45614H8.91118Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7156 7.22818H12.1865L11.4098 9.82465H9.51868L12.4736 0.175537H15.4792L18.4511 9.82465H16.4754L15.7156 7.22818ZM12.6762 5.4738H15.2091L14.2297 2.12291H13.6387L12.6762 5.4738Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4136 0.175537H22.3854L23.9051 4.07027H24.2428L25.7625 0.175537H28.768V9.82465H26.9613V2.63168H26.6236L25.0701 6.52642H23.1283L21.5918 2.63168H21.254V9.82465H19.4473V0.175537H19.4136Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5731 8.03518L35.2861 9.82465H30.5919V0.175537H36.9071L36.5693 1.96501H32.5337V3.98255H36.2654L35.9614 5.73694H32.5337V8.01765H35.5731V8.03518Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2728 4.965C43.9145 5.35096 44.3197 6.05272 44.3028 6.84219C44.3028 8.85972 42.7156 9.8071 40.9427 9.8071H36.907L38.528 0.140442H42.209C43.5261 0.140442 44.725 0.894827 44.725 2.35097C44.7418 3.33342 44.1847 4.26325 43.3066 4.66676L43.2728 4.965ZM40.8245 9.03519C42.2428 9.03519 43.4586 8.40362 43.4586 6.82467C43.4586 5.63167 42.4455 5.17553 41.4323 5.17553H38.5787L37.937 9.0001H40.8413V9.03519H40.8245ZM38.7138 4.38606H41.5843C42.8338 4.38606 43.8976 3.89483 43.8976 2.47377C43.8976 1.43869 43.0196 1.01764 42.1584 1.01764H39.3048L38.7138 4.38606Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1324 9.0351L48.7272 9.85967H45.1139L46.7349 0.192993H53.5905L53.1853 1.01755H47.4778L46.8868 4.40352H51.4457L51.0405 5.2281H46.7517L46.0932 9.0351H49.1324Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6562 9.82465H57.761L57.2376 6.71942H53.05L51.4795 9.82465H50.551L55.4138 0.175537H57.0014L58.6562 9.82465ZM53.4386 5.89485H57.0857L56.2919 1.12291H55.8024L53.4386 5.89485Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8824 0.982428H62.8091L61.3063 9.82451H60.462L61.9648 0.982428H58.892L59.0101 0.157867H66.0177L65.8824 0.982428Z",
    fill: "rgba(var(--provider-icon-color))"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9948 9.82465H66.9462L68.6177 0.175537H73.6667L71.9948 9.82465Z",
    fill: "url(#paint0_linear_125_16373)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3443 9.82465H64.2953L66.0177 0.175537H71.0667L69.3443 9.82465Z",
    fill: "url(#paint1_linear_125_16373)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_125_16373",
    x1: 70.3096,
    y1: 9.91204,
    x2: 70.3096,
    y2: 0.927994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "rgba(var(--provider-icon-color))",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgba(var(--provider-icon-color))"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_125_16373",
    x1: 67.6862,
    y1: 0.135537,
    x2: 67.6862,
    y2: 10.3433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "rgba(var(--provider-icon-color))",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgba(var(--provider-icon-color))"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_16373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.3333,
    height: 10,
    fill: "white",
    transform: "translate(0.333374)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameBet);
export default __webpack_public_path__ + "static/media/game-bet.af624374d20cf6df28cbd88ccf725659.svg";
export { ForwardRef as ReactComponent };